import Box from '@mui/material/Box';
import FormControl from '@mui/material/FormControl';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import Paper from '@mui/material/Paper';
import Select from '@mui/material/Select';
import Typography from '@mui/material/Typography';
import { FC, useState, useEffect, type JSX } from 'react';
import SormeglerenBidtheatrePreview from './SormeglerenBidtheatrePreview';
import WebmeglerBidtheatrePreview from './WebmeglerBidtheatrePreview';
import { ExternalCompanyIdEnum } from '@/shared/constants/external-company-id.enum';
import { IExtendedPreviewPropsModel } from '@/editor/shared/components/forms/creatives/models/basic-preview-props.model';
import NativeAdPreview from './NativeAdPreview';
import { useTranslation } from 'react-i18next';
import FremeiendomsmeglingBidtheatrePreview from './FremeiendomsmeglingBidtheatrePreview';
import BidtheatreClientPreview from './BidtheatreClientPreview';
import EmeraEiendomsmeglingBidtheatrePreview from './EmeraEiendomsmeglingBidtheatrePreview';
import BidtheatreVideoPreview from './BidtheatreVideoPreview';
import CreativeTypesEnum from '@/editor/shared/constants/creatives-types.enum';
import MaklerBidtheatrePreview from './MaklerBidtheatrePreview';
import { EDITOR_LS_CONSTANTS } from '@/editor/shared/constants/editor-LS.constants';
import { getValueFromLs } from '@/shared/services/localstorage';
import HettingerBidtheatrePreview from './HettingerBidtheatrePreview';

// TODO REFACTOR !!!

const BidTheatrePreviewResolver: FC<IExtendedPreviewPropsModel> = ({
  headline,
  description,
  caption,
  propertyPriceQuote,
  error,
  errorMessage,
  propertyType,
  areaInUsage,
  propertyDebt,
  ownershipType,
  companyExternalId,
  viewDate,
  nativeAd,
  employeeName,
  employeeAvatar,
  employeePhone,
  employeeEmail,
  profileTitle,
  selectedType,
  platform,
  municipality,
  profileImage,
}): JSX.Element => {
  const switchPreview = (companyExternalId: string) => {
    switch (companyExternalId) {
      case ExternalCompanyIdEnum.EIE:
      case ExternalCompanyIdEnum.EIE_VISMA:
        if (preview === 'html5') {
          return (
            <WebmeglerBidtheatrePreview
              platform={platform}
              headline={headline}
              description={description}
              propertyPriceQuote={propertyPriceQuote}
              caption={caption}
              propertyType={propertyType}
              areaInUsage={areaInUsage}
              propertyDebt={propertyDebt}
              ownershipType={ownershipType}
              viewDate={viewDate}
              nativeAd={nativeAd}
              selectedType={selectedType?.[platform as any] || selectedType}
            />
          );
        } else if (preview === 'nativead') {
          return (
            <NativeAdPreview
              platform={platform}
              headline={headline}
              caption={caption}
              viewDate={viewDate}
              nativeAd={nativeAd}
              companyExternalId={companyExternalId}
            />
          );
        }
        break;
      case ExternalCompanyIdEnum.SORMEGLEREN:
        if (preview === 'html5') {
          return (
            <SormeglerenBidtheatrePreview
              platform={platform}
              headline={headline}
              description={description}
              propertyPriceQuote={propertyPriceQuote}
              caption={caption}
              propertyType={propertyType}
              areaInUsage={areaInUsage}
              propertyDebt={propertyDebt}
              ownershipType={ownershipType}
              viewDate={viewDate}
              nativeAd={nativeAd}
              selectedType={selectedType?.[platform as any] || selectedType}
            />
          );
        } else if (preview === 'nativead') {
          return (
            <NativeAdPreview
              platform={platform}
              headline={headline}
              caption={caption}
              viewDate={viewDate}
              nativeAd={nativeAd}
              companyExternalId={companyExternalId}
            />
          );
        }
        break;
      case ExternalCompanyIdEnum.SMG:
      case ExternalCompanyIdEnum.MSPECS:
      case ExternalCompanyIdEnum.STRAND_MAKLERI:
      case ExternalCompanyIdEnum.STUDIO_FASTIGHETSMAKLERI:
      case ExternalCompanyIdEnum.HOME_BY_DEAN:
      case ExternalCompanyIdEnum.WALLIN_CO_FASTIGHETSMAKLARE_AB:
      case ExternalCompanyIdEnum.H_MAKLARE_AB:
      case ExternalCompanyIdEnum.CHRISTANDER:
      case ExternalCompanyIdEnum.EIENDOM_BROERBY:
      case ExternalCompanyIdEnum.VISBYMAKLARNA_AB:
      case ExternalCompanyIdEnum.SKOG_LANTBRUK_AB:
      case ExternalCompanyIdEnum.LIWE_ESTATE:
      case ExternalCompanyIdEnum.SJOLINSMAKLARE:
      case ExternalCompanyIdEnum.GRIPSHOLM:
      case ExternalCompanyIdEnum.BOSTADSBYRAN:
        if (preview == 'html5') {
          return (
            <BidtheatreClientPreview
              platform={platform}
              headline={headline}
              description={description}
              propertyPriceQuote={propertyPriceQuote}
              caption={caption}
              propertyType={propertyType}
              areaInUsage={areaInUsage}
              propertyDebt={propertyDebt}
              ownershipType={ownershipType}
              viewDate={viewDate}
              nativeAd={nativeAd}
              employeeName={employeeName}
              employeeAvatar={employeeAvatar}
              employeePhone={employeePhone}
              employeeEmail={employeeEmail}
              companyExternalId={companyExternalId}
              profileTitle={profileTitle}
              selectedType={selectedType?.[platform as any] || selectedType}
            />
          );
        } else if (preview === 'nativead') {
          return (
            <NativeAdPreview
              platform={platform}
              headline={headline}
              caption={caption}
              viewDate={viewDate}
              nativeAd={nativeAd}
              companyExternalId={companyExternalId}
            />
          );
        }
        break;
      case ExternalCompanyIdEnum.FREMEIENDOMSMEGLING:
        if (preview == 'html5') {
          return (
            <FremeiendomsmeglingBidtheatrePreview
              platform={platform}
              headline={headline}
              description={description}
              propertyPriceQuote={propertyPriceQuote}
              caption={caption}
              propertyType={propertyType}
              areaInUsage={areaInUsage}
              propertyDebt={propertyDebt}
              ownershipType={ownershipType}
              viewDate={viewDate}
              nativeAd={nativeAd}
              employeeName={employeeName}
              employeeAvatar={employeeAvatar}
              employeePhone={employeePhone}
              employeeEmail={employeeEmail}
              selectedType={selectedType?.[platform as any] || selectedType}
            />
          );
        } else if (preview === 'nativead') {
          return (
            <NativeAdPreview
              platform={platform}
              headline={headline}
              caption={caption}
              viewDate={viewDate}
              nativeAd={nativeAd}
              companyExternalId={companyExternalId}
            />
          );
        }
        break;
      case ExternalCompanyIdEnum.EMERA_EIE:
        if (preview == 'html5') {
          return (
            <EmeraEiendomsmeglingBidtheatrePreview
              platform={platform}
              description={description}
              caption={caption}
              areaInUsage={areaInUsage}
              viewDate={viewDate}
              nativeAd={nativeAd}
              employeeName={employeeName}
              employeeAvatar={employeeAvatar}
              employeeEmail={employeeEmail}
              employeePhone={employeePhone}
              selectedType={selectedType?.[platform as any] || selectedType}
            />
          );
        } else if (preview === 'nativead') {
          return (
            <NativeAdPreview
              platform={platform}
              headline={headline}
              caption={caption}
              viewDate={viewDate}
              nativeAd={nativeAd}
              companyExternalId={companyExternalId}
            />
          );
        }
        break;
      case ExternalCompanyIdEnum.MAKLARTEAMET:
        if (preview == 'html5') {
          return (
            <MaklerBidtheatrePreview
              platform={platform}
              headline={headline}
              description={description}
              propertyPriceQuote={propertyPriceQuote}
              caption={caption}
              propertyType={propertyType}
              areaInUsage={areaInUsage}
              propertyDebt={propertyDebt}
              ownershipType={ownershipType}
              viewDate={viewDate}
              nativeAd={nativeAd}
              employeeName={employeeName}
              employeeAvatar={employeeAvatar}
              employeePhone={employeePhone}
              employeeEmail={employeeEmail}
              selectedType={selectedType?.[platform as any] || selectedType}
              companyExternalId={companyExternalId}
              profileTitle={profileTitle}
              municipality={municipality}
              profileImage={profileImage}
            />
          );
        } else if (preview === 'nativead') {
          return (
            <NativeAdPreview
              platform={platform}
              headline={headline}
              caption={caption}
              viewDate={viewDate}
              nativeAd={nativeAd}
              companyExternalId={companyExternalId}
            />
          );
        }
        break;
      case ExternalCompanyIdEnum.HETTINGER:
        if (preview == 'html5') {
          return (
            <HettingerBidtheatrePreview
              platform={platform}
              headline={headline}
              description={description}
              propertyPriceQuote={propertyPriceQuote}
              caption={caption}
              propertyType={propertyType}
              areaInUsage={areaInUsage}
              propertyDebt={propertyDebt}
              ownershipType={ownershipType}
              viewDate={viewDate}
              nativeAd={nativeAd}
              employeeName={employeeName}
              employeeAvatar={employeeAvatar}
              employeePhone={employeePhone}
              employeeEmail={employeeEmail}
              companyExternalId={companyExternalId}
              profileTitle={profileTitle}
              selectedType={selectedType?.[platform as any] || selectedType}
            />
          );
        } else if (preview === 'nativead') {
          return (
            <NativeAdPreview
              platform={platform}
              headline={headline}
              caption={caption}
              viewDate={viewDate}
              nativeAd={nativeAd}
              companyExternalId={companyExternalId}
            />
          );
        }
        break;
      default:
        return (
          <Box component="div" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
            <Typography variant="h6">No preview available</Typography>
          </Box>
        );
    }
  };

  const { t } = useTranslation();
  const [preview, setPreview] = useState<any>('html5');
  const imageOnVideo = getValueFromLs(EDITOR_LS_CONSTANTS.IMAGE_FOR_VIDEO);
  const handleChange = (e: any) => {
    setPreview(e.target.value);
  };
  useEffect(() => {
    if (!nativeAd && (selectedType?.[platform as any] || selectedType) === CreativeTypesEnum.SINGLE) {
      setPreview('html5');
    }
  }, [nativeAd]);

  return (
    <div>
      <Box component="div">
        {nativeAd && (selectedType?.[platform as any] === CreativeTypesEnum.SINGLE || selectedType) && (
          <FormControl sx={{ my: 2 }} fullWidth>
            <InputLabel id="locale-label">Preview</InputLabel>
            <Select
              labelId="Preview"
              id="Preview"
              defaultValue={'html5'}
              name="Preview"
              value={preview}
              label="Preview"
              onChange={handleChange}>
              <MenuItem value={'html5'}>HTML 5</MenuItem>
              <MenuItem value={'nativead'}>{t('nativeAd')}</MenuItem>
            </Select>
          </FormControl>
        )}
        <Paper sx={{ border: error ? '1px solid red' : '', p: 1 }}>
          {error && errorMessage && (
            <Box component="div" sx={{ display: 'flex', justifyContent: 'flex-end' }}>
              <Typography variant="h6" color="error" sx={{ p: 2, pl: 3 }}>
                {errorMessage}
              </Typography>
            </Box>
          )}
          <div>
            {(selectedType?.[platform as any] || selectedType) == 'video' &&
            (imageOnVideo === 'video' || !imageOnVideo) ? (
              <BidtheatreVideoPreview />
            ) : (
              switchPreview(companyExternalId as string)
            )}
          </div>
        </Paper>
      </Box>
    </div>
  );
};

export default BidTheatrePreviewResolver;
